import { restRequest } from "vrcore-dashboard/dist/utilities";

export const SET_TAB_SELECTION = "SECURITY_CONFIG.SET_TAB_SELECTION";
export const SET_USER_TAB = "SECURITY_CONFIG.SET_USER_TAB";
export const GET_PERMISSIONS = restRequest("SECURITY_CONFIG.GET_PERMISSIONS");
export const SET_PERMISSIONS = restRequest("SECURITY_CONFIG.SET_PERMISSIONS");
